import React, {Suspense} from 'react';
import PageLayout from "@view/layout/pageLayout/PageLayout";
import {MutateGroupsWithListLazy} from "@containers/account/containers/group/mutateGroups/MutateGroupsWithList.lazy";
import {BREADCRUMBS_GROUPS} from "@pages/groups/constants/breadcrumbs";
import SpinnerCustom from "@ui/spinner/SpinnerCustom";

const GroupsPage = () => {
    return (
        <PageLayout breadcrumbs={BREADCRUMBS_GROUPS}>
            <Suspense
                fallback={<SpinnerCustom/>}
            >
                <MutateGroupsWithListLazy/>
            </Suspense>
        </PageLayout>
    )
};

export default GroupsPage;